export const APPLICATIONS = {
    PMA: "pma",
    APPS: "apps",
};

export const SERVER_URLS = {
    PMA_PASSWORDLESS: "https://api.jelou.ai/v1/auth/login/passwordless",
    APPS_SSO: process.env.REACT_APP_APPS_SSO_URL || "http://apps.jelou.ai/sso/",
    PMA_IMPERSONATE: process.env.REACT_APP_PMA_IMPERSONATE_URL || "https://pma.jelou.ai/impersonate/",
};
